import { render, staticRenderFns } from "./ViewSalesTable.vue?vue&type=template&id=3889f354&scoped=true"
import script from "./ViewSalesTable.vue?vue&type=script&lang=js"
export * from "./ViewSalesTable.vue?vue&type=script&lang=js"
import style0 from "./ViewSalesTable.vue?vue&type=style&index=0&id=3889f354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3889f354",
  null
  
)

export default component.exports